import { pause, unpause, is_paused } from './ajax-helpers.js';

var page,
	existingPosts,
	lastPage;

function getPosts(nextPage) {
	var nextPageNum,
		nextPagePath;

	if (existingPosts.length < 1 || existingPosts.length < 1) {
		return;
	}

	if (is_paused(existingPosts) || (nextPage === true && lastPage === true)) {
		return;
	}

	pause(existingPosts);

	nextPageNum = page + 1;

	if (window.location.pathname.match(/\/page\/(\d+)\/?/) !== null) {
		nextPagePath = window.location.pathname.replace(/\/page\/\d+\/?/, '/page/' + nextPageNum + '/');
	} else {
		nextPagePath = window.location.pathname + 'page/' + nextPageNum + '/';
	}

	$.ajax(nextPagePath, {
		method: 'GET',
		dataType: 'html',
		success: function (pageContent) {

			var htmlDoc,
				newListing,
				newPosts;

			htmlDoc = $((new DOMParser()).parseFromString(pageContent, "text/html"));
			newListing = htmlDoc.find('[data-js="blog-listing"]');
			newPosts = newListing.find('[data-js="blog-post"]');

			if (newListing.length == 0 || newListing.data('last-page') == true) {
				lastPage = true;
			}

			if (newPosts.length > 0) {
				existingPosts.append(newPosts);
			}

			eval(htmlDoc.find('#php-datalayer-events').html());

			page = nextPageNum;

			unpause(existingPosts);
		},
		error: function () {
			unpause(existingPosts);
		}
	});
}

function initBlogPagination() {

	page = 1;
	existingPosts =$('[data-js="blog-listing"]');
	lastPage = existingPosts.data('last-page');

	$(window).on('scroll', function () {
		var wHeight,
			wBot,
			postsHeight,
			postsBot;

		if (existingPosts.length < 1) {
			return;
		}

		wHeight      = window.innerHeight;
		wBot         = window.scrollY + wHeight;
		postsHeight  = existingPosts.outerHeight();
		postsBot     = existingPosts.position().top + postsHeight;

		if (wBot >= postsBot) {
			getPosts(true);
		}
	});
}

export { initBlogPagination };
